module.exports = __webpack_public_path__ + "img/home3.4e7d9033.gif";